import { createSlice } from '@reduxjs/toolkit'

export const driverSlice = createSlice({
    name: 'drivers',
    initialState: {
        drivers: [],
        driverList:[],
        activeDriver: null,
        ledger:[],
        isLoading: false,
        reload: false
    },
    reducers: {
        getDriversFetch: (state) => {
            state.isLoading = true;
        },
        getDriversSuccess: (state, action) => {
            state.isLoading = false
            state.drivers = action.payload
            state.driverList = action.payload.map(driver=>driver.name)
            state.reload = false
        },
        getDriversFail: (state) => {
            state.isLoading = false
        },
        setActiveDriver:(state,action)=>{
            state.activeDriver= action.payload
        }
        

    }
})
export const selectDrivers = (state) => state.drivers.drivers
export const selectDriverList = (state) => state.drivers.driverList
export const selectDriversIsLoading = (state) => state.drivers.isLoading
export const selectActiveDriver = (state) => state.drivers.activeDriver
export const { getDriversFetch, getDriversSuccess, getDriversFail,setActiveDriver} = driverSlice.actions;
export default driverSlice.reducer